import React from "react";
import BackendConnectionService from "../../ports/backend/backendConnectionService";
import LocalStorageService from "../../ports/localStorage/localStorageService";
import ResponseProcessorService from "../../ports/backend/ResponseProcessorService";
import { toast } from "react-toastify";
import Toastify from "../alerts/Toastify";

export default class LogoUpdaterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            logo: props.logo,
            preview: props.current,
            buttonEnabled: false,
            buttonMessage: "Seleccione una imagen"
        };
    }

    updateLogo() {
        const { preview, logo} = this.state;
        let token = LocalStorageService.getUserToken();
        BackendConnectionService.updateSiteLogo(token, logo, preview)
        .then( () => {
            this.setState({
                buttonEnabled: false,
                buttonMessage: "Seleccione una imagen"
            });
            Toastify.success(toast, "Logo actualizado con éxito");
        })
        .catch(error => {
            ResponseProcessorService.processError(error);
        });
    }

    setError(message) {
        this.setState({
            buttonEnabled: false,
            buttonMessage: message,
            preview: null
        });
    }

    getIdealSizes(logo) {
        if(logo === "header") {
            return {widthToCompare: 3177, heightToCompare: 635};
        } else if(logo === "login") {
            return {widthToCompare: 2029, heightToCompare: 1148};
        }
    }

    validateImage(image) {
        const img = new Image();
        const logo = this.state.logo;
        img.src = image;
        img.onload = () => {
            const { width, height } = img;
            const {widthToCompare, heightToCompare} = this.getIdealSizes(logo)
            if (width !== widthToCompare || height !== heightToCompare) {
                this.setError(`La imagen debe tener un tamaño de ${widthToCompare}x${heightToCompare} píxeles.`);
            } else {
                this.setState({
                    preview: image,
                    buttonEnabled: true,
                    buttonMessage: "Actualizar logo"
                });
            }
        };
        img.onerror = () => {
            this.setError("La imagen no es válida.");
        };
    }

    render() {
        let title = "";
        if (this.state.logo === "header") {
            title = "Logo de cabecera";
        } else if (this.state.logo === "login") {
            title = "Logo de inicio de sesión";
        }
        const { buttonEnabled, buttonMessage } = this.state;
        return(
            <div className="row">
            <div className="col-md-6">
                <div className="form-group mb-4">
                <label htmlFor="file">{title}</label>
                <p></p>
                <input
                    id="file"
                    type="file"
                    accept="image/png"
                    onChange={e => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const maxSize = 1024 * 1024;
                    if (file.type !== "image/png") {
                        this.setError("Solo se permiten imágenes PNG.");
                        return;
                    }
                    if (file.size > maxSize) {
                        this.setError("El archivo excede el tamaño máximo permitido (1MB).");
                        return;
                    }

                    const reader = new FileReader();
                    reader.onload = ev => {
                        this.validateImage(ev.target.result);
                    };
                    reader.readAsDataURL(file);
                    }}
                />
                <p></p>
                <button className="btn btn-success btn-block waves-effect waves-light" 
                disabled={!buttonEnabled}
                onClick={() => this.updateLogo()}
                >
                    {buttonMessage}
                </button>
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group mb-4">
                <label htmlFor="pass1">Vista previa</label>
                <p></p>
                {this.state.preview ? (
                    <div style={{
                    background: "#222",
                    display: "inline-block",
                    padding: "8px",
                    borderRadius: "4px"
                    }}>
                    <img
                        src={this.state.preview}
                        alt="Vista previa del logo"
                        style={{
                        maxWidth: "100%",
                        maxHeight: "200px",
                        border: "1px solid #ddd",
                        background: "transparent"
                        }}
                    />
                    </div>
                ) : (
                    <span>No hay vista previa disponible.</span>
                )}
                </div>
            </div>
            </div>
        );
    }
}